<div class="page-wrapper pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12">

                <div class="actions-row">
                    <mat-form-field class="search" appearance="standard">
                        <mat-label class="filter-placeholder">{{'SEARCH' | translate}}</mat-label>
                        <input matInput class="filter-input" (keyup)="applyFilter($event)" #input>
                        <div class="search-icon">
                            <fa-icon [icon]="faSearch"></fa-icon>
                        </div>
                    </mat-form-field>

                    <div class="d-flex justify-content-center mb-4">
                        <mat-button-toggle-group #toggleGroup1="matButtonToggleGroup"
                            (change)="tabChange(toggleGroup1.value)" name="fontStyle" aria-label="Actions"
                            [value]="tab">
                            <mat-button-toggle value="pending">{{'ACTIONS.REQUESTS' | translate}}</mat-button-toggle>
                            <mat-button-toggle value="renewals">{{'ACTIONS.RENEWALS' | translate}}</mat-button-toggle>
                            <mat-button-toggle value="transfers">{{'ACTIONS.TRANSFERS' | translate}}</mat-button-toggle>
                            <mat-button-toggle value="deprovisionings">{{'ACTIONS.DEPROVISIONINGS' |
                                translate}}</mat-button-toggle>
                            <mat-button-toggle value="history">{{'ACTIONS.HISTORY' | translate}}</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>

                </div>
                <div scrollHandler [tab]="tab" (nearEnd)="onNearEndScroll()" class="contents-table mat-elevation-z4">
                    <!-- Pending Action Table -->
                    <table mat-table matSort [dataSource]="pendingDataSource" class="w-100" *ngIf="tab === 'pending'">
                        <caption>Request info</caption>
                        <!-- Check Column -->
                        <ng-container matColumnDef="check">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? pendingMasterToggle() : null"
                                    [checked]="pendingSelection.hasValue() && isAllPendingSelected()"
                                    [indeterminate]="pendingSelection.hasValue() && !isAllPendingSelected()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex justify-content-start" *ngIf="!isOnDeliveryStatus(element)">
                                    <mat-checkbox (click)="$event.stopPropagation()" class="col-6"
                                        (change)="$event ? pendingSelection.toggle(element) : null"
                                        [checked]="pendingSelection.isSelected(element)">
                                    </mat-checkbox>
                                    <fa-icon class="font-22 me-4" [icon]="faUserGroup" placement="top"
                                        [ngbTooltip]="'From: '+element.approver"></fa-icon>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Submission Column -->
                        <ng-container matColumnDef="submission">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="submittedAt" sortActionDescription="Sort by Submission">
                                {{'PENDING_ACTION_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="resourceName" sortActionDescription="Sort by Type">
                                {{'PENDING_ACTION_INFO.TYPE' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Action ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="requestId" sortActionDescription="Sort by ID">
                                {{'PENDING_ACTION_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.requestId}} </td>
                        </ng-container>

                        <!-- Author Column -->
                        <ng-container matColumnDef="author">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="author" sortActionDescription="Sort by Author">
                                {{'PENDING_ACTION_INFO.AUTHOR' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.author}} </td>
                        </ng-container>

                        <!-- Step Column -->
                        <ng-container matColumnDef="step">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                {{'PENDING_ACTION_INFO.STATUS' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                                <app-status-indicator [status]="element.status"></app-status-indicator>
                            </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell class="user-select-none font-15 text-center" *matHeaderCellDef>
                                {{'PENDING_ACTION_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="openInfo(element)" class="cursor-pointer font-24"
                                    [icon]="faCircleInfo">
                                </fa-icon>
                            </td>
                        </ng-container>

                        <!-- Complete action Column -->
                        <ng-container matColumnDef="complete">
                            <th mat-header-cell class="user-select-none font-15 text-center" *matHeaderCellDef>
                                {{'PENDING_ACTION_INFO.COMPLETE' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon *ngIf="isOnDeliveryStatus(element)" (click)="openCompleteAction(element)"
                                    class="cursor-pointer font-24 ms-2" [icon]="faTruck">
                                </fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>

                    <!-- Renewal Action Table -->
                    <table mat-table matSort [dataSource]="renewalsDataSource" class="w-100" *ngIf="tab === 'renewals'">
                        <caption>Request info</caption>
                        <!-- Check Column -->
                        <ng-container matColumnDef="check">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? renewalMasterToggle() : null"
                                    [checked]="renewalSelection.hasValue() && isAllRenewalSelected()"
                                    [indeterminate]="renewalSelection.hasValue() && !isAllRenewalSelected()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex justify-content-start">
                                    <mat-checkbox (click)="$event.stopPropagation()" class="col-6"
                                        (change)="$event ? renewalSelection.toggle(element) : null"
                                        [checked]="renewalSelection.isSelected(element)">
                                    </mat-checkbox>
                                    <fa-icon class="font-22 me-4" [icon]="faUserGroup" placement="top"
                                        [ngbTooltip]="'From: '+element.approver"></fa-icon>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Submission Column -->
                        <ng-container matColumnDef="submission">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="submittedAt" sortActionDescription="Sort by Submission">
                                {{'RENEWAL_ACTION_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="resourceName" sortActionDescription="Sort by Type">
                                {{'RENEWAL_ACTION_INFO.TYPE' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Action ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="requestId" sortActionDescription="Sort by ID">
                                {{'RENEWAL_ACTION_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.requestId}} </td>
                        </ng-container>

                        <!-- Title Column -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="title" sortActionDescription="Sort by Title">
                                Title </th>
                            <td mat-cell *matCellDef="let element"> {{element.title}} </td>
                        </ng-container>

                        <!-- Author Column -->
                        <ng-container matColumnDef="author">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="author" sortActionDescription="Sort by Author">
                                {{'RENEWAL_ACTION_INFO.AUTHOR' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.author}} </td>
                        </ng-container>

                        <!-- Step Column -->
                        <ng-container matColumnDef="step">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                {{'RENEWAL_ACTION_INFO.STATUS' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                                <app-status-indicator [status]="element.status"></app-status-indicator>
                            </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell class="user-select-none font-15 text-center" *matHeaderCellDef>
                                {{'RENEWAL_ACTION_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="openInfo(element)" class="cursor-pointer info-btn font-24"
                                    [icon]="faCircleInfo">
                                </fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsRenewal; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsRenewal;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>

                    <!-- Transfer Action Table -->
                    <table mat-table matSort [dataSource]="transfersDataSource" class="w-100"
                        *ngIf="tab === 'transfers'">
                        <caption>Action info</caption>
                        <!-- Check Column -->
                        <ng-container matColumnDef="check">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? transferMasterToggle() : null"
                                    [checked]="transferSelection.hasValue() && isAllTransferSelected()"
                                    [indeterminate]="transferSelection.hasValue() && !isAllTransferSelected()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex justify-content-start">
                                    <mat-checkbox (click)="$event.stopPropagation()" class="col-6"
                                        (change)="$event ? transferSelection.toggle(element) : null"
                                        [checked]="transferSelection.isSelected(element)">
                                    </mat-checkbox>
                                    <fa-icon class="font-22 me-4" [icon]="faUserGroup" placement="top"
                                        [ngbTooltip]="'From: '+element.approver"></fa-icon>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Submission Column -->
                        <ng-container matColumnDef="submission">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="submittedAt" sortActionDescription="Sort by Submission">
                                {{'TRANSFER_ACTION_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="resourceName" sortActionDescription="Sort by Type">
                                {{'TRANSFER_ACTION_INFO.TYPE' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Action ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="requestId" sortActionDescription="Sort by ID">
                                {{'TRANSFER_ACTION_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.requestId}} </td>
                        </ng-container>

                        <!-- Title Column -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="title" sortActionDescription="Sort by Title">
                                Title </th>
                            <td mat-cell *matCellDef="let element"> {{element.title}} </td>
                        </ng-container>

                        <!-- Author Column -->
                        <ng-container matColumnDef="author">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                {{'TRANSFER_ACTION_INFO.AUTHOR' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.author}} </td>
                        </ng-container>

                        <!-- Step Column -->
                        <ng-container matColumnDef="step">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                {{'TRANSFER_ACTION_INFO.STATUS' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                                <app-status-indicator [status]="element.status"></app-status-indicator>
                            </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell class="user-select-none font-15 text-center" *matHeaderCellDef>
                                {{'TRANSFER_ACTION_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="openInfo(element)" class="cursor-pointer info-btn font-24"
                                    [icon]="faCircleInfo">
                                </fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsTransfer; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsTransfer;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>

                    <!-- Deprovisioning Action Table -->
                    <table mat-table matSort [dataSource]="deprovisioningsDataSource" class="w-100"
                        *ngIf="tab === 'deprovisionings'">
                        <caption>Request info</caption>
                        <!-- Check Column -->
                        <ng-container matColumnDef="check">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? deprovisioningMasterToggle() : null"
                                    [checked]="deprovisioningSelection.hasValue() && isAllDeprovisioningSelected()"
                                    [indeterminate]="deprovisioningSelection.hasValue() && !isAllDeprovisioningSelected()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex justify-content-start">
                                    <mat-checkbox (click)="$event.stopPropagation()" class="col-6"
                                        (change)="$event ? deprovisioningSelection.toggle(element) : null"
                                        [checked]="deprovisioningSelection.isSelected(element)">
                                    </mat-checkbox>
                                    <fa-icon class="font-22 me-4" [icon]="faUserGroup" placement="top"
                                        [ngbTooltip]="'From: '+element.approver"></fa-icon>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Submission Column -->
                        <ng-container matColumnDef="submission">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="submittedAt" sortActionDescription="Sort by Submission">
                                {{'TRANSFER_ACTION_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="resourceName" sortActionDescription="Sort by Type">
                                {{'TRANSFER_ACTION_INFO.TYPE' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Action ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="requestId" sortActionDescription="Sort by ID">
                                {{'TRANSFER_ACTION_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.requestId}} </td>
                        </ng-container>

                        <!-- Title Column -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="title" sortActionDescription="Sort by Title">
                                Title </th>
                            <td mat-cell *matCellDef="let element"> {{element.title}} </td>
                        </ng-container>

                        <!-- Author Column -->
                        <ng-container matColumnDef="author">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="author" sortActionDescription="Sort by Author">
                                {{'TRANSFER_ACTION_INFO.AUTHOR' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.author}} </td>
                        </ng-container>

                        <!-- Step Column -->
                        <ng-container matColumnDef="step">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                {{'TRANSFER_ACTION_INFO.STATUS' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                                <app-status-indicator [status]="element.status"></app-status-indicator>
                            </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell class="user-select-none font-15 text-center" *matHeaderCellDef>
                                {{'TRANSFER_ACTION_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="openInfo(element)" class="cursor-pointer info-btn font-24"
                                    [icon]="faCircleInfo">
                                </fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsDeprovisioning; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsDeprovisioning;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>

                    <!-- History Action Table -->
                    <table mat-table
                         matSort [dataSource]="historyDataSource" 
                        class="w-100 nv-scroll-table" *ngIf="tab === 'history'">
                        <caption>Request info</caption>
                        <!-- Submission Column -->
                        <ng-container matColumnDef="submitted">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="submittedAt" sortActionDescription="Sort by Submission">
                                {{'ACTION_HISTORY_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="resourceName" sortActionDescription="Sort by Type">
                                {{'ACTION_HISTORY_INFO.TYPE' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Action ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="requestId" sortActionDescription="Sort by ID">
                                {{'ACTION_HISTORY_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.requestId}} </td>
                        </ng-container>

                        <!-- Author Column -->
                        <ng-container matColumnDef="author">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef
                                mat-sort-header="author" sortActionDescription="Sort by Author">
                                {{'ACTION_HISTORY_INFO.AUTHOR' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.author}} </td>
                        </ng-container>

                        <!-- Step Column -->
                        <ng-container matColumnDef="step">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                {{'ACTION_HISTORY_INFO.STATUS' | translate}} </th>
                            <td mat-cell *matCellDef="let element">

                                <app-status-indicator [status]="element.status"></app-status-indicator>

                            </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell class="user-select-none font-15 text-center" *matHeaderCellDef>
                                {{'ACTION_HISTORY_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="openInfo(element)" class="cursor-pointer font-24"
                                    [icon]="faCircleInfo">
                                </fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsHist; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsHist"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="pendingSelection.selected.length > 0 && tab === 'pending'">
            <div class="col-6 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action success new-request-btn"
                    (click)="approveSelected()">{{'ACTIONS.APPROVE' | translate}}
                    ({{pendingSelection.selected.length}})</button>
            </div>
            <div class="col-6 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action error new-request-btn"
                    (click)="rejectSelected()">{{'ACTIONS.REJECT' | translate}}
                    ({{pendingSelection.selected.length}})</button>
            </div>
        </div>
        <div class="row" *ngIf="renewalSelection.selected.length > 0 && tab === 'renewals'">
            <div class="col-6 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action success new-request-btn"
                    (click)="approveSelected()">{{'ACTIONS.APPROVE' | translate}}
                    ({{renewalSelection.selected.length}})</button>
            </div>
            <div class="col-6 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action error new-request-btn"
                    (click)="rejectSelected()">{{'ACTIONS.REJECT' | translate}}
                    ({{renewalSelection.selected.length}})</button>
            </div>
        </div>
        <div class="row" *ngIf="transferSelection.selected.length > 0 && tab === 'transfers'">
            <div class="col-6 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action success new-request-btn"
                    (click)="approveSelected()">{{'ACTIONS.APPROVE' | translate}}
                    ({{transferSelection.selected.length}})</button>
            </div>
            <div class="col-6 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action error new-request-btn"
                    (click)="rejectSelected()">{{'ACTIONS.REJECT' | translate}}
                    ({{transferSelection.selected.length}})</button>
            </div>
        </div>
        <div class="row" *ngIf="deprovisioningSelection.selected.length > 0 && tab === 'deprovisionings'">
            <div class="col-6 d-flex justify-content-center mt-4 mb-3">
                <button mat-flat-button class="btn-action success new-request-btn"
                    (click)="approveSelected()">{{'ACTIONS.APPROVE' | translate}}
                    ({{deprovisioningSelection.selected.length}})</button>
            </div>
            <div class="col-6 d-flex justify-content-center mt-4 mb-3">
                <button mat-flat-button class="btn-action error new-request-btn"
                    (click)="rejectSelected()">{{'ACTIONS.REJECT' | translate}}
                    ({{deprovisioningSelection.selected.length}})</button>
            </div>
        </div>
    </div>
</div>